"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.global_api = void 0;
var _lsfastapiClient = require("@lsoft/lsfastapi-client");
var openapi = {
  openapi: "3.1.0",
  info: {
    title: "global-api",
    version: "2.2.4"
  },
  paths: {
    "/currency/{currency}": {
      get: {
        tags: ["currency"],
        summary: "Currency Get",
        operationId: "currency__currency__get",
        parameters: [{
          name: "currency",
          "in": "path",
          required: true,
          schema: {
            type: "string",
            title: "Currency"
          }
        }, {
          name: "changerates",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            "default": false,
            title: "Changerates"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/Currency"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/currency/change_rate": {
      put: {
        tags: ["currency"],
        summary: "Currency Changerate Put",
        operationId: "currency_change_rate_put",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/CurrencyChangeRate"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/CurrencyChangeRate"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/currency/{currency}/change_rate": {
      get: {
        tags: ["currency"],
        summary: "Currency Changerate Get",
        operationId: "currency__currency__change_rate_get",
        parameters: [{
          name: "currency",
          "in": "path",
          required: true,
          schema: {
            type: "string",
            title: "Currency"
          }
        }, {
          name: "DATE",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string",
              format: "date"
            }, {
              type: "null"
            }],
            title: "Date"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/CurrencyChangeRate"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/currencies": {
      get: {
        tags: ["currency"],
        summary: "Currencies Get",
        operationId: "currencies_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    },
    "/email/account": {
      put: {
        tags: ["recipient"],
        summary: "Add Newsletter Registration Put",
        operationId: "email_account_put",
        parameters: [{
          name: "email",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Email"
          }
        }, {
          name: "newsletter_name",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Newsletter Name"
          }
        }, {
          name: "newsletter_group",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Newsletter Group"
          }
        }, {
          name: "language",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Language"
          }
        }, {
          name: "optin",
          "in": "query",
          required: true,
          schema: {
            type: "boolean",
            title: "Optin"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/emails/by_newsletter_name": {
      put: {
        tags: ["recipient"],
        summary: "Get All Emails By Newsletter Name",
        operationId: "emails_by_newsletter_name_put",
        parameters: [{
          name: "newsletter_name",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Newsletter Name"
          }
        }, {
          name: "group",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Group"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/update/supressions": {
      put: {
        tags: ["recipient"],
        summary: "Update Suppressions",
        operationId: "update_supressions_put",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    },
    "/email/optin_confirmed": {
      put: {
        tags: ["recipient"],
        summary: "Optin Email Confirmed Put",
        operationId: "email_optin_confirmed_put",
        parameters: [{
          name: "hash",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Hash"
          }
        }, {
          name: "locale",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Locale"
          }
        }, {
          name: "mailing_list",
          "in": "query",
          required: true,
          schema: {
            title: "Mailing List"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/newsletter": {
      post: {
        tags: ["newsletter"],
        summary: "Newsletter Post",
        operationId: "newsletter_post",
        parameters: [{
          name: "newsletter",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Newsletter"
          }
        }, {
          name: "newsletter_group",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Newsletter Group"
          }
        }, {
          name: "id",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Id"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/NewsletterModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      patch: {
        tags: ["newsletter"],
        summary: "Newsletter Patch",
        operationId: "newsletter_patch",
        parameters: [{
          name: "newsletter",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Newsletter"
          }
        }, {
          name: "newsletter_group",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Newsletter Group"
          }
        }],
        requestBody: {
          required: true,
          content: {
            "application/json": {
              schema: {
                type: "object",
                title: "Body"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/NewsletterModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      put: {
        tags: ["newsletter"],
        summary: "Newsletter Update Or Create Put",
        operationId: "newsletter_put",
        parameters: [{
          name: "newsletter",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Newsletter"
          }
        }, {
          name: "newsletter_group",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Newsletter Group"
          }
        }, {
          name: "unsubscribe_group_id",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Unsubscribe Group Id"
          }
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                type: "object",
                title: "Body"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/NewsletterModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      "delete": {
        tags: ["newsletter"],
        summary: "Newsletter Delete",
        operationId: "newsletter_delete",
        parameters: [{
          name: "newsletter",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Newsletter"
          }
        }, {
          name: "newsletter_group",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Newsletter Group"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      get: {
        tags: ["newsletter"],
        summary: "Newsletter Get",
        operationId: "newsletter_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    },
    "/healthz": {
      get: {
        summary: "Healthz Get",
        operationId: "healthz_get_healthz_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    }
  },
  components: {
    schemas: {
      ChangeRate: {
        properties: {
          UPDATED: {
            type: "string",
            format: "date",
            title: "Updated"
          },
          EUR_VALUE: {
            type: "number",
            title: "Eur Value"
          }
        },
        type: "object",
        required: ["UPDATED", "EUR_VALUE"],
        title: "ChangeRate"
      },
      Currency: {
        properties: {
          CURRENCY: {
            type: "string",
            title: "Currency"
          },
          CHANGE_RATES: {
            anyOf: [{
              items: {
                $ref: "#/components/schemas/ChangeRate"
              },
              type: "array"
            }, {
              type: "null"
            }],
            title: "Change Rates",
            "default": []
          }
        },
        type: "object",
        required: ["CURRENCY"],
        title: "Currency"
      },
      CurrencyChangeRate: {
        properties: {
          CURRENCY: {
            type: "string",
            title: "Currency"
          },
          UPDATED: {
            anyOf: [{
              type: "string",
              format: "date"
            }, {
              type: "null"
            }],
            title: "Updated"
          },
          EUR_VALUE: {
            type: "number",
            title: "Eur Value"
          }
        },
        type: "object",
        required: ["CURRENCY", "EUR_VALUE"],
        title: "CurrencyChangeRate"
      },
      HTTPValidationError: {
        properties: {
          detail: {
            items: {
              $ref: "#/components/schemas/ValidationError"
            },
            type: "array",
            title: "Detail"
          }
        },
        type: "object",
        title: "HTTPValidationError"
      },
      NewsletterModel: {
        properties: {
          newsletter_group: {
            type: "string",
            title: "Newsletter Group"
          },
          newsletter: {
            type: "string",
            title: "Newsletter"
          },
          unsubscribe_group_id: {
            type: "string",
            title: "Unsubscribe Group Id"
          }
        },
        type: "object",
        required: ["newsletter_group", "newsletter", "unsubscribe_group_id"],
        title: "NewsletterModel"
      },
      ValidationError: {
        properties: {
          loc: {
            items: {
              anyOf: [{
                type: "string"
              }, {
                type: "integer"
              }]
            },
            type: "array",
            title: "Location"
          },
          msg: {
            type: "string",
            title: "Message"
          },
          type: {
            type: "string",
            title: "Error Type"
          }
        },
        type: "object",
        required: ["loc", "msg", "type"],
        title: "ValidationError"
      }
    }
  }
};
var global_api = exports.global_api = (0, _lsfastapiClient.Api)(openapi);
//# sourceMappingURL=index.js.map